import React, { Component } from "react";
import {
  Form,
  FormField,
  ComboBox,
  Panel,
  LinkButton,
  DateBox,
  Messager,
} from "rc-easyui";
import { isEmpty, getFormattedDate } from "../../../helpers";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

const axios = require("axios");

class ActivateMaintainance extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }
  static propTypes = {
    userFields: PropTypes.object,
    validationRules: PropTypes.object,
    operation: PropTypes.string,
    handleChange: PropTypes.func,
    formClear: PropTypes.func,
    enabled: PropTypes.array,
    clientsList: PropTypes.array,
  };

  handleChange(name, value) {
    this.props.handleChange(name, value);
  }

  async handleSave() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.userFields);
    form["startDate"] = getFormattedDate(form["startDate"]);
    form["endDate"] = getFormattedDate(form["endDate"]);
    let apiUrl = `${API_URL}api/activatemaintenancemode`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(apiUrl, form, headersConfig)
            .then((response) => {
              //console.log("response", response);
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan  Saved Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        //console.log("Front End Form Validaion ");
      }
    });
  }

  handleUpdate() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.userFields);
    form["startDate"] = getFormattedDate(form["startDate"]);
    form["endDate"] = getFormattedDate(form["endDate"]);
    let apiUrl = `${API_URL}api/activatemaintenancemode/${form.id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(apiUrl, form, headersConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              //console.log("error", error);
              this.setState({
                isLoading: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.field.toUpperCase() +
                      " " +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        alert("Front End Form Validaion ");
      }
    });
  }

  render() {
    const user = this.props.userFields;
    const clientsList = this.props.clientsList;
    const modeStatus = this.props.enabled;
    const rules = this.props.validationRules;
    const loading = this.state.isLoading;
    const operation = this.props.operation;
    return (
      <div>
        <Panel title='Client Maintainance Mode' bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <Form
            ref={this.props.innerRef}
            model={user}
            labelWidth={400}
            labelAlign='left'
            rules={rules}
            // validateRules={this.customValidations()}
            labelPosition='top'
            onChange={this.handleChange.bind(this)}
          >
            <FormField name='clientId' label='Clients:'>
              <ComboBox
                style={{ width: "100%" }}
                data={clientsList}
                value={user.clientId}
                valueField='clientid'
                textField='organizationname'
              ></ComboBox>
            </FormField>
            <FormField name='enabled' label='Maintainance Mode:'>
              <ComboBox
                data={modeStatus}
                valueField='value'
                textField='text'
                value={user.enabled}
                editable={false}
              ></ComboBox>
            </FormField>
            <FormField name='startDate' label='Start Date:'>
              <DateBox
                format='yyyy-MM-dd'
                value={user.startDate}
                // calendarOptions={{
                //   validator: (date) => {
                //     let now = new Date();
                //     let d1 = new Date(
                //       now.getFullYear(),
                //       now.getMonth(),
                //       now.getDate()
                //     );

                //     return d1 <= date;
                //   },
                // }}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </FormField>
            <FormField name='endDate' label='End Date:'>
              <DateBox
                format='yyyy-MM-dd'
                value={user.endDate}
                // calendarOptions={{
                //   validator: (date) => {
                //     let now = new Date();
                //     let d2 = new Date(
                //       now.getFullYear(),
                //       now.getMonth(),
                //       now.getDate()
                //     );

                //     return d2 <= date;
                //   },
                // }}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </FormField>
            <hr />
            <div className='text-center'>
              <Button
                color='primary'
                disabled={loading ? true : false}
                onClick={
                  operation === "Add" ? this.handleSave : this.handleUpdate
                }
                style={{ marginRight: 20 }}
              >
                {operation === "Add" ? "Save" : "Update"}
              </Button>
              <Button color='danger' onClick={this.props.formClear}>
                Cancel
              </Button>
            </div>
          </Form>
        </Panel>
      </div>
    );
  }
}
export default React.forwardRef((props, ref) => (
  <ActivateMaintainance innerRef={ref} {...props} />
));
